module.exports = __webpack_public_path__ + "img/img49.f90eb5bc.svg";